import React from 'react';
import {Icon, TextField, css, view} from '@sail/ui';
import * as everyIcon from '@sail/icons/react/Icon';

const getIconList = (everyImport) =>
  Object.keys(everyImport)
    .sort()
    .map((iconKey) => ({
      icon: everyImport[iconKey],
      label: iconKey,
    }));

const icons = {
  icon: getIconList(everyIcon),
};

const wrapperStyles = css({
  width: css.value('650px'),
  height: css.value('595px'),
  overflow: css.value('auto'),
  border: css.value('1px solid $borderColor.neutral'),
  borderRadius: 'medium',
  background: 'surface',
});

const styles = css({
  display: css.value('grid'),
  paddingY: 'large',
  paddingX: 'small',
  width: css.value('100%'),
  gridTemplateColumns: css.value(
    'repeat(auto-fill, minmax(min(100px, 100%), 1fr))',
  ),
  gap: 'xlarge',
});

const tileStyles = css({
  display: css.value('flex'),
  flexDirection: css.value('column'),
  gap: 'small',
  alignItems: css.value('center'),
  paddingY: 'small',

  '& > span': {
    font: 'caption',
  },
});

const getIconGroupSizeByCategory = (category) => {
  if (category === 'brand' || category === 'social') {
    return 'xlarge';
  } else if (category === 'feature' || category === 'product') {
    return 'large';
  } else if (category === 'card') {
    return 'medium';
  }
  return null;
};

export const EveryIcon = ({category = 'icon'}) => {
  const [filter, setFilter] = React.useState('');
  const iconSet = icons[category];
  const filteredIcons = iconSet.filter((icon) => {
    if (filter) {
      return icon.label.toLowerCase().includes(filter.toLowerCase());
    }
    return true;
  });
  return (
    <view.div>
      <TextField
        label="Filter"
        hiddenElements={['label']}
        placeholder="Filter"
        css={{marginBottom: 'small'}}
        value={filter}
        onChange={(e) => setFilter(e.target.value)}
      />
      <view.div uses={[wrapperStyles]}>
        {!filteredIcons.length && (
          <view.div
            css={{
              textAlign: 'center',
              marginTop: css.value('42%'),
              color: 'secondary',
            }}
          >
            No icons found.
          </view.div>
        )}
        <view.div uses={[styles]}>
          {filteredIcons.map((iconAsset, idx) => (
            <view.div key={idx} uses={[tileStyles]}>
              <Icon
                icon={iconAsset.icon}
                size={getIconGroupSizeByCategory(category)}
              />
              <span>{iconAsset.label}</span>
            </view.div>
          ))}
        </view.div>
      </view.div>
    </view.div>
  );
};
